import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/toxicology/residual-solvents-reports")({
  beforeLoad: () => { throw redirect({ href: "/zh-cn/services/regulatory-toxicology/residual-solvents-reports", statusCode: 301 }); },
});
